import {AppState} from '../reducer';
import {LiveRoomReportDTO, QuestionAnswersCount, QuestionReport} from '../../incase-domain/analytics';

export const questionReportsSelector = (state: AppState): QuestionReport[] => state.analyticsReducer.questionReports;
export const questionUserAnswersCountSelector = (state: AppState): QuestionAnswersCount[] => state.analyticsReducer.questionAnswersCountAll;
export const liveRoomReportSelector = (state: AppState): LiveRoomReportDTO | undefined => state.analyticsReducer.liveRoomReport;
